export const BlockchainExplorerUrl = {
  TOBALABA: "https://tobalaba-explorer.energyweb.org",
  EWC: "https://explorer.anyblock.tools/ethereum/ewf/ewc",
  VOLTA: "https://explorer.anyblock.tools/ethereum/ewf/volta"
}


// WEBPACK FOOTER //
// ./src/enums/BlockchainExplorer.js